export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const resolveAvailabilityMsg = function (product, type= 'available') {
    if (process.env.REACT_APP_SHOW_STOCK === "0") {
        return '';
    }

    let cases_stock = type === 'available' ? product.StockCases : product.StockOnOrderCases;
    let bottles_stock = type === 'available' ? product.StockTotalBottles : product.StockOnOrderBottles;

    // Hide 'on order' stock if it both zero or show 'Currently Out of Stock'.
    if (cases_stock < 1 && bottles_stock < 1) {
        return type === 'available' ? 'Currently Out of Stock' : '';
    }

    let cases_ending = cases_stock !== 1 ? 'cases' : 'case';
    let cases_part = cases_stock > 0 && shouldShowCasesInput(product) ?
      `${cases_stock} ${product.CustomLabel ?? cases_ending}` :
      '';

    let bottles_ending = bottles_stock !== 1 ? 'bottles' : 'bottle';
    let bottles_part = bottles_stock > 0 && shouldShowBottlesInput(product) ?
      `${bottles_stock} ${bottles_ending}` :
      '';

    // Don't display 'available' word if cases and blocks are empty.
    if (cases_part.length < 1 && bottles_part.length < 1) {
        return 'Currently Out of Stock';
    }

    // When both are filled, add 'and'.
    if (cases_part.length > 1 && bottles_part.length > 1) {
        cases_part = cases_part + ' and ';
    }

    return `${cases_part}${bottles_part} ${type}`;
}

export const calculateRrpFromMargin = function (margin, basePrice) {
  if (isNaN(margin) || margin < 0 || margin > 100 || !basePrice) {
    return false;
  }
  // RRP = Cost Price / (1 - Desired Profit Margin)
  const basePriceRounded = Math.round((basePrice * 1000) / 10) / 100;
  const priceWithRRP = (basePriceRounded / (1 - (margin / 100)));
  const VAT = priceWithRRP * 0.2;

  return priceWithRRP + VAT;
}

/**
 * Determines if the cases quantity input should be displayed for a product.
 *
 * Shows cases input if:
 * - Is cases-only mode OR
 * - Not in bottles-only mode (UNIT_FLAG !== "1") AND
 * - Product has a CaseSize of 1 (single unit products) OR Stock available
 */
export const shouldShowCasesInput = function (product) {
  let stock = product.StockCases + ((process.env.REACT_APP_SHOW_STOCK === '2' || process.env.REACT_APP_SHOW_STOCK === '3') ? product.StockOnOrderCases : 0);
  return process.env.REACT_APP_UNIT_FLAG === "2" || (process.env.REACT_APP_UNIT_FLAG !== "1" && (stock > 0 || product.CaseSize === 1));
}

/**
 * Determines if the bottles quantity input should be displayed for a product.
 *
 * Shows bottles input if ALL of the following conditions are met:
 * 1. Selling individual bottles is allowed (one of these must be true):
 *    a) REACT_APP_ONLY_SELL_MULTIPLES_OF is enabled AND product.OnlySellMultiplesOf <= 1
 *       AND not cases-only mode (UNIT_FLAG !== "2")
 *    b) REACT_APP_ONLY_SELL_MULTIPLES_OF is not enabled AND not cases-only mode (UNIT_FLAG !== "2")
 *
 * 2. Either bottles-only mode is active OR product has a case size > 1:
 *    - REACT_APP_UNIT_FLAG === "1" (bottles-only mode), OR
 *    - product.CaseSize > 1 (product is sold in cases, so bottles need to be shown separately)
 */
export const shouldShowBottlesInput = function (product) {
  return (
    (
      (process.env.REACT_APP_ONLY_SELL_MULTIPLES_OF && product.OnlySellMultiplesOf <= 1 && process.env.REACT_APP_UNIT_FLAG !== "2") ||
      (!process.env.REACT_APP_ONLY_SELL_MULTIPLES_OF && process.env.REACT_APP_UNIT_FLAG !== "2")
    ) &&
    (process.env.REACT_APP_UNIT_FLAG === "1" || product.CaseSize > 1)
  );
}
